// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as IconUpArrow$Showside from "../icons/IconUpArrow.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as StickyHeaderOffsetProvider$Showside from "../context/StickyHeaderOffsetProvider.bs.js";
function isEnabled(category, settings, isForcingPLP, appliedFilters) {
  if (category !== undefined) {
    if (Category$Showside.hasProducts(category) && (!Category$Showside.hasSubCategories(category) || isForcingPLP)) {
      return Category$Showside.ExternalConnection.isConnectedToProductSource(category);
    } else {
      return false;
    }
  } else if (Belt_Option.mapWithDefault(settings.indexNode, false, function (indexNode) {
    return Belt_Option.isSome(Category$Showside.ExternalConnection.getStoreCategoryConnection(indexNode));
  })) {
    return Belt_Option.isSome(appliedFilters);
  } else {
    return false;
  }
}
function BackToTopButton(Props) {
  var scrollableContainerRef = Props.scrollableContainerRef;
  var positionOpt = Props.position;
  var position = positionOpt !== undefined ? positionOpt : "absolute";
  var match = ViewportContext$Showside.use(undefined);
  var windowHeight = match.windowSize.height;
  var isMobile = match.isMobile;
  var embedTop = StickyHeaderOffsetProvider$Showside.useContainerTop(undefined);
  var match$1 = React.useState(function () {
    return false;
  });
  var setShow = match$1[1];
  var scrollableElement = React.useRef({
    TAG: /* Window */0,
    _0: window
  });
  var onClick = function (e) {
    var w = scrollableElement.current;
    if (w.TAG === /* Window */0) {
      w._0.scrollTo({
        behavior: "smooth",
        left: 0.0,
        top: embedTop
      });
      return;
    }
    w._0.scrollTo({
      behavior: "smooth",
      left: 0.0,
      top: 0.0
    });
  };
  var onScroll = function (e) {
    var scrollTop = e.target.scrollTop;
    var actualScrollTop = scrollTop == null ? window.scrollY | 0 : scrollTop | 0;
    Curry._1(setShow, function (param) {
      return actualScrollTop > windowHeight;
    });
  };
  React.useEffect(function () {
    var el = Belt_Option.flatMap(scrollableContainerRef, function (ref) {
      return Caml_option.nullable_to_opt(ref.current);
    });
    var tmp;
    if (el !== undefined) {
      var el$1 = Caml_option.valFromOption(el);
      scrollableElement.current = {
        TAG: /* Element */1,
        _0: el$1
      };
      el$1.addEventListener("scroll", onScroll);
      tmp = function (param) {
        el$1.removeEventListener("scroll", onScroll);
      };
    } else {
      window.addEventListener("scroll", onScroll);
      tmp = function (param) {
        window.removeEventListener("scroll", onScroll);
      };
    }
    return tmp;
  }, []);
  return React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make([position, "bottom-0 left-0", isMobile ? "bottom-22" : "bottom-12", "pointer-events-none"]))
  }, React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["h-13.5 w-13.5", "border-1.5 border-solid border-accent", "relative", "rounded-full bg-accent text-main no-touch-highlight", "flex items-center justify-center", "cursor-pointer", "shadow-lg hover:shadow-xl", "dark-hover darker-active", isMobile ? "left-6" : "left-12", match$1[0] ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none", "transition-opacity duration-300", "transform scale-110"])),
    title: "Scroll back to top",
    onClick: onClick
  }, React.createElement(IconUpArrow$Showside.make, {})));
}
BackToTopButton.displayName = "BackToTopButton";
var make = BackToTopButton;
export { isEnabled, make };
/* react Not a pure module */